import { useEffect } from 'react';

import { usePerformanceActions, usePerformanceChannelCategoryDates } from 'src/store';
import { WEBSITE_CHANNELS } from 'src/data/performance';

export const useFetchWebsiteAccounts = () => {
  const performanceActions = usePerformanceActions();

  const performanceChannelCategoryDates = usePerformanceChannelCategoryDates(WEBSITE_CHANNELS);

  useEffect(() => {
    performanceActions.queryWebsiteAccounts();
  }, [performanceActions, performanceChannelCategoryDates]);
};
